<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :title="title"
      width="50%"
      :modal-append-to-body="false"
      @close="handleClose"
    >
      <!-- 表单 -->
      <div style="display: flex; justify-content: center">
        <el-form :model="params" :rules="rules" label-width="120px" ref="form">
          <el-form-item label="渠道配置：" prop="channel">
            <!-- 单选 radio -->
            <el-radio-group v-model="params.channel">
              <el-radio label="1">全部渠道</el-radio>
              <el-radio label="2">指定渠道</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="params.channel === '2'" label="渠道选择：">
            <el-input
              type="textarea"
              @focus="handleClick()"
              v-model="params.appidFilterNames"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="价格样式：" prop="useType">
            <!-- 单选radio 基础价格 折扣价格 -->
            <el-radio-group v-model="params.useType">
              <el-radio label="1">原价样式</el-radio>
              <el-radio label="2">折扣价样式</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="原价：" prop="former">
            <el-input
              style="width: 200px"
              :maxlength="99"
              v-model="params.former"
              placeholder="请输入原价"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="params.useType === '2'" label="现价：" prop="now">
            <el-input
              style="width: 200px"
              :maxlength="99"
              v-model="params.now"
              placeholder="请输入现价"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格后缀：" prop="suffix">
            <el-input
              style="width: 200px"
              :maxlength="99"
              v-model="params.suffix"
              placeholder="请输入价格后缀"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 关闭按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">保存</el-button>
        <el-button @click="hide">取消</el-button>
      </span>
    </el-dialog>
    <channel-popups
      :isAppendToBody="false"
      :modelIsAppendToBody="false"
      :app-id="params.appidFilterList"
      :visible.sync="showPopups"
      @comfirm="handleConfirm"
    ></channel-popups>
  </div>
</template>

<script>
import ChannelPopups from "@/components/channel-popups";
import Message from "@/components/Message";
import {
  addPriceApi,
  editPriceApi,
} from "@/api/mediaManage/mediaContentManage";
export default {
  name: "WebSassformerAdd",
  components: { ChannelPopups },
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          id: "",
          appidFilterList: [],
          appidFilterNames: "",
          channel: "1",
          useType: "1",
          former: "",
          now: "",
          suffix: "",
        };
      },
    },
  },
  computed: {
    /** 是否是编辑 */
    title() {
      return this.params.id ? "定价编辑" : "定价新增";
    },
  },
  /** 监听对话框打开的事件 */
  watch: {
    visible(newVal) {
      if (newVal) {
        console.log("拿到的id", this.params.id);
      }
    },
  },
  data() {
    return {
      /** 渠道选择框的显隐 */
      showPopups: false,
      visible: false,
      /** 表单的验证规则 */
      rules: {
        channel: [
          {
            required: true,
            message: "请选择渠道配置",
            trigger: "blur",
          },
        ],
        useType: [
          {
            required: true,
            message: "请选择价格展示",
            trigger: "blur",
          },
        ],
        former: [
          {
            required: true,
            message: "请输入原价",
            trigger: "blur",
          },
        ],
        now: [
          {
            required: true,
            message: "请输入现价",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    /** 处理数据的方法 */
    handleData() {
      const params = { ...this.params };
      /** 处理渠道数据 */
      if (this.params.channel !== "1") {
        const channelIds = this.params.appidFilterList.split(",");
        const channelNames = this.params.appidFilterNames.split(",");
        const channelList = [];
        for (let i = 0; i < channelIds.length; i++) {
          channelList.push({
            channelId: Number(channelIds[i]),
            channelName: channelNames[i],
          });
        }
        params.channelList = channelList;
      } else {
        const channelList = [
          {
            channelId: 0,
            channelName: "全部渠道",
          },
        ];
        params.channelList = channelList;
      }
      params.mediaId = this.$route.query.id;
      return params;
    },
    /** 确认保存的事件 */
    handleSave() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          /** 验证通过 */
          console.log("验证通过");
          /** 处理数据 */
          const params = this.handleData();
          console.log("处理后的数据", params);
          if (!params.id) {
            const { data } = await addPriceApi(params);
            console.log("保存的响应", data);
            if (data.code === 200) {
              Message.success("保存成功");
              /** 通知父组件更新列表数据 */
              this.$emit("updateList");
            }
          } else {
            const { data } = await editPriceApi(params);
            console.log("保存的响应", data);
            if (data.code === 200) {
              Message.success("保存成功");
              /** 通知父组件更新列表数据 */
              this.$emit("updateList");
            }
          }

          this.hide();
        } else {
          /** 验证失败 */
          Message.error("请检查表单");
        }
      });
    },
    show(id, params) {
      console.log("show", id);
      this.params.id = id ? id : "";
      console.log("params", params);
      if (params) {
        this.params = { ...params };
        if (this.params.id && this.params.channelList[0].channelId === 0) {
          // 用$set赋值
          this.$set(this.params, "channel", "1");
        } else {
          this.$set(this.params, "channel", "2");
          // this.params.channel = '1'
          try {
            this.params.appidFilterList = this.params.channelList
              .map((item) => {
                return String(item.channelId);
              })
              .join(",");
            this.params.appidFilterNames = this.params.channelList
              .map((item) => {
                return item.channelName;
              })
              .join(",");
          } catch (error) {
            this.params.appidFilterList = "";
            this.params.channelName = "";
          }
        }
        this.params.useType = String(this.params.useType);
      }
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    handleClose() {
      console.log("beforeClose");
      /** 清理表单数据 */
      this.$refs.form.resetFields();
      this.params = {
        id: "",
        appidFilterList: [],
        appidFilterNames: "",
        channel: "1",
        useType: "1",
        former: "",
        now: "",
        suffix: "",
      };
    },
    /** 确认渠道选择 */
    handleConfirm(data) {
      console.log("渠道选择的数据", data);
      const { appId, nameStr } = data;
      this.params.appidFilterList = appId;
      this.params.appidFilterNames = nameStr;
      // this.$nextTick(() => {
      //   this.$refs['form'] && this.$refs['form'].clearValidate()
      // })
    },
    /** 渠道选择框 */
    handleClick() {
      this.showPopups = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
